"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.HTMLIdentifier = void 0;
class HTMLIdentifier {
  identifyHTML(html) {
    const re = new RegExp(/<[a-z][\s\S]*>/);
    return re.test(html);
  }
}
exports.HTMLIdentifier = HTMLIdentifier;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJuYW1lcyI6WyJIVE1MSWRlbnRpZmllciIsImlkZW50aWZ5SFRNTCIsImh0bWwiLCJyZSIsIlJlZ0V4cCIsInRlc3QiLCJleHBvcnRzIl0sInNvdXJjZXMiOlsiLi4vLi4vc3JjL3NlcnZpY2VzL2h0bWxJZGVudGlmaWVyLnRzIl0sInNvdXJjZXNDb250ZW50IjpbImV4cG9ydCBjbGFzcyBIVE1MSWRlbnRpZmllciB7XG4gIHB1YmxpYyBpZGVudGlmeUhUTUwoaHRtbDogc3RyaW5nKSB7XG4gICAgY29uc3QgcmUgPSBuZXcgUmVnRXhwKC88W2Etel1bXFxzXFxTXSo+Lyk7XG4gICAgcmV0dXJuIHJlLnRlc3QoaHRtbCk7XG4gIH1cbn1cbiJdLCJtYXBwaW5ncyI6Ijs7Ozs7O0FBQU8sTUFBTUEsY0FBYyxDQUFDO0VBQ25CQyxZQUFZQSxDQUFDQyxJQUFZLEVBQUU7SUFDaEMsTUFBTUMsRUFBRSxHQUFHLElBQUlDLE1BQU0sQ0FBQyxnQkFBZ0IsQ0FBQztJQUN2QyxPQUFPRCxFQUFFLENBQUNFLElBQUksQ0FBQ0gsSUFBSSxDQUFDO0VBQ3RCO0FBQ0Y7QUFBQ0ksT0FBQSxDQUFBTixjQUFBLEdBQUFBLGNBQUEifQ==